<page-heading
  [title]="'response.home.pageTitle' | translate"
  [description]="'response.home.pageDescription' | translate"
/>

<ul class="nav nav-tabs nav-bordered mb-3">
  <li class="nav-item">
    <a
      class="nav-link active"
      id="quick-tab"
      data-bs-toggle="tab"
      data-bs-target="#quick"
      type="button"
      role="tab"
      aria-controls="quick"
      aria-selected="true"
    >
      <i class="mdi mdi-home-variant d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'response.home.tabQuickReplies' | translate }}</span>
    </a>
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      id="alert-tab"
      data-bs-toggle="tab"
      data-bs-target="#alert-words"
      type="button"
      role="tab"
      aria-controls="alert-words"
      aria-selected="false"
    >
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'response.home.tabAlertWords' | translate }}</span>
    </a>
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      id="categories-tab"
      data-bs-toggle="tab"
      data-bs-target="#categories"
      type="button"
      role="tab"
      aria-controls="categories"
      aria-selected="false"
    >
      <i class="mdi mdi-settings-outline d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'response.home.tabCategories' | translate }}</span>
    </a>
  </li>
</ul>

<div class="tab-content" id="tabComponentsContent">
  <div
    class="tab-pane fade show active"
    id="quick"
    role="tabpanel"
    aria-labelledby="quick-tab"
  >
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form [formGroup]="formGroup">
              <div class="row">
                <div class="col-xs-12 col-lg-6 input-trend-search">
                  <input
                    type="search"
                    #searchBox
                    class="form-control"
                    [placeholder]="'response.home.searchPlaceholder' | translate"
                    formControlName="search"
                    (keyup)="search(searchBox.value)"
                  />
                  <span class="mdi mdi-magnify search-icon ml-2"></span>
                </div>

                <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
                  <button
                    type="submit"
                    [matMenuTriggerFor]="menu"
                    class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
                  >
                    <span>
                      {{ labelFilter ?? ('response.home.categories' | translate) }}
                    </span>
                  </button>
                  <mat-menu #menu class="custom-menu-panel">
                    <button mat-menu-item (click)="selectedCategory('')">
                      {{ 'response.home.all' | translate }}
                    </button>
                    @for (category of listCategory; track $index) {
                      <button
                        mat-menu-item
                        (click)="selectedCategory(category.name)"
                      >
                        {{ category ? category.name : "" }}
                      </button>
                    }
                  </mat-menu>
                </div>

                <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
                  <button class="btn btn-success fw-bold" (click)="add()">
                    {{ 'response.home.addButton' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      @if (loadingContent) {
        <content-loading-list></content-loading-list>
      }

      @if (pager.total == 0) {
        <empty-records-component
          [message]="'response.home.emptyMessage' | translate"
          [subMessage]="'response.home.emptySubMessage' | translate"
          [labelButton]="'response.home.addButton' | translate"
          [icon]="'mdi mdi-alert-circle-outline'"
          (emitEvent)="add()"
        />
      }

      @if (!loadingContent && pager.total > 0) {
        <div class="card-body table-responsive">
          <table class="table table-hover table-centered mb-0">
            <thead>
              <tr>
                <th class="text-primary-emphasis">{{ 'response.home.tableName' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'response.home.tableCategory' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'response.home.tableMessage' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'response.home.tableAttachment' | translate }}</th>
                <th><span class="sr-only"></span></th>
              </tr>
            </thead>
            <tbody>
              @for (item of pager.list; track $index) {
                <tr>
                  <td>{{ item.name || "-" }}</td>
                  <td>{{ item.category?.name ?? "-" }}</td>
                  <td>{{ item.message | truncate: 50 }}</td>
                  <td>{{ getFileExtension(item) }}</td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <button
                        type="button"
                        class="btn btn-dropdown-list"
                        [matMenuTriggerFor]="menu"
                      >
                        <i
                          class="mdi mdi-dots-vertical text-primary-emphasis"
                        ></i>
                      </button>

                      <mat-menu #menu="matMenu">
                        @if (item.midia) {
                          <button
                            mat-menu-item
                            tabindex="0"
                            (click)="preview(item)"
                          >
                            {{ 'response.home.actionView' | translate }}
                          </button>
                        }
                        <button mat-menu-item tabindex="0" (click)="edit(item)">
                          {{ 'response.home.actionEdit' | translate }}
                        </button>
                        @if (isAdmin()) {
                          <button
                            mat-menu-item
                            tabindex="0"
                            (click)="delete(item)"
                          >
                            {{ 'response.home.actionDelete' | translate }}
                          </button>
                        }
                      </mat-menu>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>

          @if (pager.total > pager.perPage) {
            <paginator [pager]="pager" (onPager)="loadPage($event)" />
          }
        </div>
      }
    </div>
  </div>

  <div
    class="tab-pane fade"
    id="alert-words"
    role="tabpanel"
    aria-labelledby="alert-tab"
  >
    <warning-word-component></warning-word-component>
  </div>

  <div
    class="tab-pane fade"
    id="categories"
    role="tabpanel"
    aria-labelledby="categories-tab"
  >
    <category-component></category-component>
  </div>
</div>
